import styled from '@emotion/styled/macro';
import { getEnvironment } from '@sunrun/sales-experience-shared';
import { useRef } from 'react';
import { publishMessage, useSubscribe } from 'helpers/messaging';
import type { Message } from 'helpers/messaging';

const ChatIframe = ({
  contactId,
  drawer = false,
}: {
  contactId: string;
  drawer: boolean;
}) => {
  const ref = useRef<HTMLIFrameElement | null>(null);

  const env = getEnvironment();

  const chatBaseUrl =
    env === 'production'
      ? 'https://saleschat.ai.sunrun.com/contacts/'
      : 'https://saleschat.staging.ai.sunrun.com/contacts/';

  useSubscribe((message: Message) => {
    // Send message "upward" to Container
    if (message.source === 'Chat') {
      publishMessage({ ...message, source: 'Dashboard' });
    }

    // Send message "downward" to Chat
    if (message.source === 'Auth') {
      if (ref.current) {
        ref.current.contentWindow?.postMessage(
          { ...message, source: 'Dashboard' },
          { targetOrigin: '*' },
        );
      }
    }
  });

  useSubscribe((message: Message) => {
    if (
      message.source === 'Chat' &&
      message.type === 'CHAT:CLOSING_CHAT_CONVERSATION'
    ) {
      const escapeEvent = new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true,
        cancelable: true,
      });

      document.dispatchEvent(escapeEvent);
    }
  });

  return (
    <IFrameContainer
      ref={ref}
      src={`${chatBaseUrl}${contactId}?embed=true&drawer=${drawer}`}
      title="Chat"
    />
  );
};

const IFrameContainer = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

export { ChatIframe };
